import { LitElement, css, html } from "lit";

export class CzIcon extends LitElement {
	static styles = css`
		@layer component {
			:host {
				--_cz-icon-color: var(--cz-icon-color, currentcolor);
				--_cz-icon-width: var(--cz-icon-width, 50px);
				--_cz-icon-height: var(--cz-icon-height, 50px);
				display: block;
				width: var(--_cz-icon-width);
				height: var(--_cz-icon-height);
				max-width: var(--_cz-icon-width);
				max-height: var(--_cz-icon-height);
			}
			
			:host(cz-icon[type=stroke]) ::slotted(svg) {
				stroke: var(--_cz-icon-color);
				fill: transparent;
			}
			
			::slotted(svg) {
				fill: var(--_cz-icon-color);
				width: 100%;
				height: 100%;
			}
		}
	`;

	static properties = {
		type: {type: String},
		name: {type: String}
	};

	constructor() {
		super();
		this.type = 'fill';
		this.name = 'chevron';
	}

	render() {
		return html`<slot></slot>`;
	}
}

if (!customElements.get('cz-icon')) {
	customElements.define('cz-icon', CzIcon);
}